import { render, staticRenderFns } from "./CreateBrokerOrBankModal.vue?vue&type=template&id=21206e0d&scoped=true"
import script from "./CreateBrokerOrBankModal.vue?vue&type=script&lang=js"
export * from "./CreateBrokerOrBankModal.vue?vue&type=script&lang=js"
import style0 from "./CreateBrokerOrBankModal.vue?vue&type=style&index=0&id=21206e0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21206e0d",
  null
  
)

export default component.exports